<template>
  <div class="bed-manager__container">
    <!-- Header -->
    <div class="pageHeader page-header page-header__flex">
      Bed Manager
    </div>

    <!-- Action Bar -->
    <div style="position: relative;">
      <b-skeleton 
        style="background-color: rgb(50 181 200 / 44%); transition: all 500ms; height: 0; opacity: 0;" animation="fade" width="100%"
        :style="bedManagerService.actions && bedManagerService.actions.length ? 'height: 16px; opacity: 1;' : 'height: 0px !important;'"
      >
      </b-skeleton>
      <span v-if="bedManagerService.actions && bedManagerService.actions.length" 
        style="
          transition: all 1500ms;
          position: absolute;
          top: 0;
          background: transparent;
          background-color: transparent;
          font-size: 0px;
          color: #484848;
          margin-left: 15px;
          opacity: 0;
        "
        :style="bedManagerService.actions && bedManagerService.actions.length ? 'opacity: 1; font-size: 12px' : ''"
        >
        {{bedManagerService.actions[0].label}}
      </span>
    </div>

    <!-- Body -->
    <div class="body">
      <div>
        <b-tabs v-if="Array.isArray(this.bedManagerService.tenants.data) && this.bedManagerService.tenants.data.length" content-class="mt-3" v-model="tabIndex">
          <b-tab v-if="this.userPermissions && this.userPermissions.includes(JOBS_PERMISSION)" :title-link-class="'dm__tab-link'" title="Jobs">
            <jobs></jobs>
          </b-tab>
          <b-tab v-if="this.userPermissions && this.userPermissions.includes(DEVICES_PERMISSION)" :title-link-class="'dm__tab-link'" title="Beds">
            <bm-devices></bm-devices>
          </b-tab>
          <b-tab v-if="this.userPermissions && this.userPermissions.includes(PACKAGES_PERMISSION)" :title-link-class="'dm__tab-link'" title="Packages">
            <packages></packages>
          </b-tab>
          <b-tab 
            v-if="Array.isArray(this.bedManagerService.selectedJob.data) && this.bedManagerService.selectedJob.data.length && this.userPermissions && this.userPermissions.includes(JOBS_PERMISSION)" 
            :title-link-class="'dm__tab-link'">
            <template #title>
              <div style="display: flex; justify-content: space-between; gap: 5px; flex-wrap: nowrap; align-items: center;">
                <span>{{ bedManagerService.selectedJob.data[0].tenant }} - {{ bedManagerService.selectedJob.data[0].jobId }}</span>
                <b-button @click.prevent="closeJob" class="bed-manager__button--close" style="position: relative; top: 0; left: 0; height: 20px; width: 20px;">x</b-button>
              </div>
            </template>
            <bm-job></bm-job>
          </b-tab>
          <b-tab 
            v-if="this.bedManagerService.selectedDevice.id && this.userPermissions && this.userPermissions.includes(DEVICES_PERMISSION)" 
            :title-link-class="'dm__tab-link'">
            <template #title>
              <div style="display: flex; justify-content: space-between; gap: 5px; flex-wrap: nowrap; align-items: center;">
                <span>{{ bedManagerService.selectedDevice.id }}</span>
                <b-button @click.prevent="closeDevice" class="bed-manager__button--close" style="position: relative; top: 0; left: 0; height: 20px; width: 20px;">x</b-button>
              </div>
            </template>
            <bm-device-attributes></bm-device-attributes>
          </b-tab>
        </b-tabs>
        <div class="bed-manager__footer">v{{ VERSION }} BM</div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from "vue";
  import VueToast from "vue-toast-notification";
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  import BedManagerService from "./BedManager.service";
  import TenantsAPIService from "../../shared/services/api/Tenants.service";
  import LocationAPIService from "../../shared/services/api/Locations.service";
  import DeviceManagerAPIService from "../../shared/services/api/DeviceManager.service";
  import Packages from "./packages/Packages.vue";
  import Jobs from "./jobs/Jobs.vue";
  import Devices from "./devices/Devices.vue";
  import DeviceAttributes from "./device-attributes/DeviceAttributes.vue";
  import Job from "./job/Job.vue";

  const version = require('../../../package.json').version;
  const moment = require("moment");
  
  Vue.use(VueToast);
  Vue.use(Loading);
  Vue.component('packages', Packages);
  Vue.component('jobs', Jobs);
  Vue.component('bm-job', Job);
  Vue.component('bm-devices', Devices);
  Vue.component('bm-device-attributes', DeviceAttributes);
  
  export default {
    name: "BedManager",
    components: { },
    data() {
      return {
        console: console,
        moment: moment,

        // State and API Request Services
        bedManagerService: BedManagerService,
        deviceManagerAPIService: DeviceManagerAPIService,
        tenantsService: TenantsAPIService,
        locationService: LocationAPIService,

        // Local State
        VERSION: version,
        PACKAGES_PERMISSION: 'app:mgr',
        DEVICES_PERMISSION: 'manage:devices',
        JOBS_PERMISSION: 'manage:devices',
        userPermissions: [],
        packageInterval: null,
      };
    },
    computed: {
      tenant() {
        return this.bedManagerService.tenants.selected;
      },
      tabIndex() {
        return this.bedManagerService.tabIndex;
      }
    },
    watch: {
      tenant() {
        this.locationService.fetchLocations({ tenantName: this.tenant.value }).then((res) => {
          if (Array.isArray(res)) {
            this.bedManagerService.locations = { selected: res[0].value, data: res };

            const treeHeader = this.bedManagerService.devices.headers.find((header) => header.key === 'poc');
            treeHeader.treeData = res.map((location) => {
              const item = {
                id: location.locationId,
                name: location.name,
                expanded: false,
                selected: false,
                children: Array.isArray(location.units) ? location.units.map((unit) => {
                  const unitFormatted = {
                    id: unit.id,
                    name: unit.name,
                    expanded: false,
                    selected: false,
                    children: Array.isArray(unit.areas) ? unit.areas.map((area) => {
                      const areaFormatted = {
                        id: area.id,
                        name: area.name,
                        expanded: false,
                        selected: false,
                      }
                      return areaFormatted;
                    }) : [],
                  }
                  return unitFormatted;
                }) : [],
              }
              return item;
            })

            this.bedManagerService.devices.headers = [...this.bedManagerService.devices.headers]
          }
        });
      }
    },
    mounted() {
      // Initial Data Points Pulled
      this.bedManagerService.fetchConfiguration();
      this.tenantsService.fetchTenants().then((res) => {
        if (Array.isArray(res)) {
          res.unshift({ text: 'Select Tenant', value: null })
          this.bedManagerService.tenants = { selected: res[0], data: res };
          res.forEach((item) => {
            this.bedManagerService.devices.headers[1].searchItems.push(item);
            this.bedManagerService.jobs.headers[0].searchItems.push(item);
          })
        }
      });

      // Gather perms
      this.gatherPermissions();

      // Set Packages & Start Poll
      this.packageInterval = setInterval(() => {
        this.bedManagerService.fetchPackages();
      }, this.bedManagerService.DEFAULT_POLL_INTERVAL_IN_SECS * 1000);

      // Used as ON DESSTROY
      this.$router.afterEach(() => {
        try {
          clearInterval(this.packageInterval);
        } catch (e) { this.console.log(e); }
      });
    },
    unmounted() {

    },
    methods: {
      async gatherPermissions() {
        // Permission Set
        const claims = await this.$auth.getIdTokenClaims();
        this.userPermissions = claims["https://care.ai/permissions"];
      },
      async closeJob() {
        this.bedManagerService.selectedJob = { ...this.bedManagerService.selectedJob, data: [], id: null }; 
        this.bedManagerService.tabIndex = 0;
      },
      async closeDevice() {
        this.bedManagerService.selectedDevice = { ...this.bedManagerService.selectedDevice, id: null, data: [] }; 
        this.bedManagerService.tabIndex = 1;
      }
    }
  };
</script>
  
  <!-- Scoped Styles -->
  <style lang="scss">
    div.isNotReady {
      height: 15px;
      width: 15px;
      border-radius: 50%;
      background: radial-gradient(circle at 5px 5px, #ff5c5c, #291919);
      opacity: .5;
    }
    div.isReady {
      height: 15px;
      width: 15px;
      border-radius: 50%;
      background: radial-gradient(circle at 5px 5px, #61bf5e, #1c2919);
      opacity: .5;
    }
  </style>  

  <!-- Global Styles (Use with Caution) -->
  <style lang="scss">
    .bed-manager__container {
      .page-header {
        &__flex {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        height: 56px;
        color: #fff;
        background: #ffffff;
        font-size: 15px;
        padding: 0 15px;
        color: #5f5f5f;
        border-bottom: 1px solid #e6e6e6;
      }
    }
    body .bed-manager__container {
      .nav-tabs .dm__tab-link {
        color: #5f5f5f;
        transition: color 500ms;
        border: none;
        font-size: 15px;

        &:hover {
          color: #1dd8f6;
        }

        &.active {
          color: #1dd8f6;
          border-color: #1dd8f6;
          border-bottom: 3px solid #1dd8f6;
        }
      }
    }
  </style>
  
  <style>
  ::-webkit-scrollbar {
    width: 6px; 
    height: 6px;
  }
  .bed-manager__container {
    .bed-manager__footer {
      position: fixed;
      bottom: 0;
      width: 100%;
      z-index: 50;
      background: white;
      padding: 5px 10px;
      border-top: 1px solid #dee2e6;
      font-size: 10px;
    }
    .tab-pane {
      position: relative;
    }
    .bed-manager__button--close {
      position: absolute;
      top: 20px;
      right: 25px;
      font-size: 12px;
      z-index: 15;
      height: 25px;
      width: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
      transition: all 500ms;
      background-color: #effefe;
      border: 1px solid rgba(0,181,218,.4);
      color: #c8c8c8;

      &:hover {
          background-color: #1dd8f6;
          color: white;
      }
    }
    .mt-3 {
      margin-top: 1px !important;
    }
    .nav-tabs {
      border: none;
    }
  }
  </style>
  